import type { Dispatch, AnyAction } from 'redux';

import type { GroupedDivisions } from 'ab-viewModels/division.viewModel';

import type DivisionRequestModel from 'ab-requestModels/division.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function create(form: DivisionRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.RESOURCES.DIVISION.CREATE(), { ...form });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function update(divisionId: number, form: DivisionRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.put(API.V1.RESOURCES.DIVISION.EDIT(divisionId.toString()), { ...form });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteDivision(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.delete(API.V1.RESOURCES.DIVISION.DELETE(id.toString()));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllForCompany() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<GroupedDivisions>(API.V1.RESOURCES.DIVISION.LIST(''));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
